<template>
    <div>
        <div class="flex items-center justify-between">
            <div
                v-if="bills"
                class="px-4 py-5 space-y-6 bg-white"
            >
                <!-- Bill Number -->
                <div class="flex items-center  gap-4">
                    Bill Number: {{ bills.bill_number }}
                </div>

                <div class="flex items-center  gap-4">
                    Total Amount: {{ config(common.currency) }} {{ bills.total_amount }}
                </div>

                <div class="flex items-center  gap-4">
                    Pending Amount: {{ config(common.currency) }} {{ bills.amount_remaining }}
                </div>

                <div class="flex items-center  gap-4">
                    Payment Method: {{ deliveredPayload.paymentType }}
                </div>

                <!-- Payment Method -->
                <div
                    class="flex w-full"
                >
                    <label
                        for="table-search"
                        class="flex items-center mr-2"
                    >
                        Payment Using:
                    </label>
                    <t-radio-group
                        v-model="paymentUsed"
                        :classes="{
                            groupWrapper: 'flex justify-around items-center gap-4',
                            label: 'ml-2 text-gray-700 uppercase text-sm font-semibold',
                            input:
                                'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed',
                        }"
                        :options="['CASH', 'BANK', 'BOTH']"
                    />
                </div>

                <div v-if="paymentUsed == 'CASH' || paymentUsed == 'BOTH'">
                    <div class="block text-sm font-medium text-gray-700">
                        Cash Amount
                    </div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="deliveredPayload.cashAmount"
                            type="text"
                            placeholder="Cash Amount"
                        />
                    </div>
                </div>

                <div v-if="paymentUsed == 'BANK' || paymentUsed == 'BOTH'">
                    <div class="block text-sm font-medium text-gray-700">
                        Cheque Amount
                    </div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="deliveredPayload.checkAmount"
                            type="text"
                            placeholder="Cheque Amount"
                        />
                    </div>
                </div>

                <div v-if="paymentUsed == 'BANK' || paymentUsed == 'BOTH'">
                    <div class="flex items-center justify-between mb-6">
                        Cheque Detail
                        <t-button
                            type="button"
                            variant="success"
                            class="px-3 py-1 text-white bg-green-500 border rounded cursor-pointer"
                            @click="addNewRow()"
                        >
                            Add next
                        </t-button>
                    </div>
                    <div
                        v-for="(item, index) in deliveredPayload.checkPayments"
                        :key="index"
                        class="flex gap-5"
                    >
                        <div>
                            <div class="block text-sm font-medium text-gray-700">
                                Bank
                            </div>
                            <div class="flex flex-col mt-1 rounded-md shadow-sm">
                                <t-rich-select
                                    v-model="item.bankId"
                                    :options="bankList.data"
                                    :clearable="true"
                                    value-attribute="id"
                                    text-attribute="name"
                                    placeholder="Bank Name"
                                />
                            <!-- <t-input
                                v-model="deliveredPayload.checkPayments[0].bankId"
                                type="text"
                                placeholder="Bank"
                            /> -->
                            </div>
                        </div>
                        <div>
                            <div class="block text-sm font-medium text-gray-700">
                                Cheque No.
                            </div>
                            <div class="flex flex-col mt-1 rounded-md shadow-sm">
                                <t-input
                                    v-model="item.checkNumber"
                                    type="text"
                                    placeholder="Cheque Number"
                                />
                            </div>
                        </div>
                        <div>
                            <div class="block text-sm font-medium text-gray-700">
                                Cheque Amt.
                            </div>
                            <div class="flex flex-col mt-1 rounded-md shadow-sm">
                                <t-input
                                    v-model="item.checkAmount"
                                    type="text"
                                    placeholder="Cheque Amount"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <t-button
                    type="button"
                    variant="success"
                    @click="changeStatusToDelivered()"
                >
                    Received Payment
                </t-button>
            </div>
        </div>

        <portal
            v-if="show"
            to="notify"
        >
            <Notify
                :message="message"
                :status="status"
                @closeNotify="show = false; status = null; message = null"
            />
        </portal>
    </div>
</template>

<script>

import axios from 'axios';
import common from '../../common';
import Notify from '../../Components/Notify.vue';

export default {
    components: { Notify },
    props: {
        bills: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            billId: this.bills.id,
            show: false,
            status: null,
            message: null,
            common,
            paymentUsed: 'CASH',
            bankList: [],
            deliveredPayload: {
                paymentType: this.bills.payment_method,
                cashAmount: '',
                checkAmount: '',
                checkPayments: [
                    {
                        checkNumber: '',
                        checkAmount: '',
                        bankId: 0,
                    },
                ],
            },
        };
    },

    async mounted() {
        await this.fetchBanks();
    },

    methods: {
        changeStatusToDelivered() {
            if (this.deliveredPayload.cashAmount == null || this.deliveredPayload.cashAmount === '') {
                this.deliveredPayload.cashAmount = 0;
            }
            if (this.deliveredPayload.checkAmount == null || this.deliveredPayload.checkAmount === '') {
                this.deliveredPayload.checkAmount = 0;
            }

            if (this.deliveredPayload.checkPayments.length < 2
            && this.deliveredPayload.checkPayments[0].bankId === 0) {
                this.deliveredPayload.checkPayments = [];
            }
            axios.get(route('bill.delivered', this.billId), {
                headers: {
                    Accept: 'application/json',
                },
                params: this.deliveredPayload,
            })
                .then((res) => {
                    this.show = true;
                    this.status = res.status;
                    this.message = res.data.success;
                    this.$emit('closeModal');
                })
                .catch((ex) => {
                    this.show = true;
                    this.status = ex.response.status;
                    this.message = ex.response.data.error;
                });
        },

        async fetchBanks() {
            await this.$axios.get(route('banks.index')).then((res) => {
                this.bankList = res.data.banks;
            });
        },

        addNewRow() {
            const errorflag = this.validateChequeData();
            console.log(errorflag);
            if (errorflag) {
                this.deliveredPayload.checkPayments.push({
                    checkNumber: '',
                    checkAmount: '',
                    bankId: 0,
                });
            }
        },
        validateChequeData() {
            // eslint-disable-next-line consistent-return
            let result = true;
            this.deliveredPayload.checkPayments.forEach((checkPayment) => {
                if (checkPayment !== undefined) {
                    if (checkPayment.checkNumber === '') {
                        result = false;
                    }
                    if (checkPayment.checkAmount === '') {
                        console.log(checkPayment.checkAmount);
                        result = false;
                    }
                    if (parseInt(checkPayment.bankId) === 0) {
                        console.log(checkPayment.bankId);
                        result = false;
                    }
                } else {
                    result = false;
                }
            });
            return result;
        },
    },
};
</script>
